/**
 * TopBar - 56px sticky top bar for /chat route.
 *
 * MD-31 ASKLAW-EMBER-THEME Phase 2. Per spec F-FE-THEME-GEMINI §6.3.
 *
 * Layout (Phase 1B refine, spec 2026-06-15 muc 13.4 B2):
 *   - Left: hamburger toggle (mobile only) + avatar + TEN hoi thoai + subtitle
 *   - Right: Eraser icon (clear chat)
 *
 * Telegram-style: header hien ten hoi thoai dang mo (thay vi thanh trang rong).
 * title rong (greeting) -> placeholder "Cuoc tro chuyen moi". subtitle = so luot
 * hoi hoac nhan AI tham khao.
 *
 * ThemeToggle chuyen sang AccountPopover tren NavRail (app shell spec
 * 2026-06-12-telegram-liquid-glass) - TopBar thu gon thanh thread header.
 *
 * Model selector chip removed 2026-05-27 per founder (single model, no switch
 * UI needed; defer multi-model dropdown to Stage C when actually shippable).
 *
 * Sticky position top:0 z-index 30. Glass surface (chat.css).
 */

import { EraserIcon, MenuIcon } from './icons';

export type TopBarProps = {
  lang: 'vi' | 'en';
  onToggleSidebar?: () => void;
  /** Whether to show hamburger toggle (mobile). */
  showMobileToggle?: boolean;
  /** Optional onClick for temp/clear chat. */
  onClearChat?: () => void;
  /** Ten hoi thoai dang mo. Rong/undefined -> placeholder greeting. */
  title?: string;
  /** Dong phu duoi title (vd "2 luot hoi" hoac "AI tham khao"). */
  subtitle?: string;
};

export function TopBar({
  lang,
  onToggleSidebar,
  showMobileToggle = true,
  onClearChat,
  title,
  subtitle,
}: TopBarProps) {
  const heading =
    title?.trim() || (lang === 'vi' ? 'Cuộc trò chuyện mới' : 'New conversation');
  const sub = subtitle?.trim() || (lang === 'vi' ? 'AI tham khảo' : 'AI reference');
  const avatarInitial = (title?.trim()?.charAt(0) || 'A').toUpperCase();
  return (
    <div className="chat-topbar" data-chat-topbar role="banner">
      <div className="chat-topbar__left">
        {showMobileToggle && (
          <button
            type="button"
            className="chat-topbar__hamburger"
            onClick={onToggleSidebar}
            aria-label={
              lang === 'vi' ? 'Mở danh sách trò chuyện' : 'Open conversations'
            }
          >
            <MenuIcon size={18} strokeWidth={1.8} />
          </button>
        )}
        <span className="chat-topbar__avatar" aria-hidden="true">
          {avatarInitial}
        </span>
        <div className="chat-topbar__title-wrap">
          <span className="chat-topbar__title" title={heading}>
            {heading}
          </span>
          <span className="chat-topbar__subtitle">{sub}</span>
        </div>
      </div>
      <div className="chat-topbar__right">
        {onClearChat && (
          <button
            type="button"
            className="chat-topbar__clear"
            onClick={onClearChat}
            aria-label={
              lang === 'vi' ? 'Bắt đầu trò chuyện mới' : 'Start new chat'
            }
            title={lang === 'vi' ? 'Trò chuyện mới' : 'New chat'}
          >
            <EraserIcon size={16} strokeWidth={1.6} />
          </button>
        )}
      </div>
    </div>
  );
}

export default TopBar;
